<!--
 * @Author: xionggang
 * @Date: 2021-07-27 13:35:28
 * @LastEditTime: 2022-08-02 11:18:02
-->
<template>
  <div v-if="false" class="vedio-box">
    <template v-if="isloading">
      <van-loading size="24px" vertical>加载中...</van-loading>
    </template>
    <template v-else>
      <go-back @goBack="goBack"></go-back>
      <span class="gobackBtn" @click="goBack">
        <img alt src="@/assets/images/icon/back1.png"/>
      </span>
      <template v-if="!showCourseShelf">
        <div class="swiper-video">
          <swiper-video
              ref="swiper"
              :centeredSlides="true"
              :loop="false"
              :slidesNum="1"
              :swipeid="'jc_doctor_swiper'"
              @slideChange="slideChange"
          >
            <div
                v-for="(item, index) in courseList"
                :key="index"
                slot="swiper-con"
                class="swiper-slide"
            >
              <div v-lazy:background-image="item.imgUrl" class="head">
                <span
                    v-if="
                    index === courseList.length - 1 &&
                      courseList[courseList.length - 1].isGreat &&
                      (!isPaypoint || isGoLogin) &&
                      !scanCode
                  "
                    class="tag"
                >
                  {{
                    isGoLogin
                        ? "登录获积分观看好课"
                        : showPointTag
                            ? "积分兑换"
                            : ""
                  }}
                </span>
                <div v-if="!playStatus" class="head_btn">
                  <img :src="foodPause" @click="exchange(item, index)"/>
                </div>
                <div class="video_num">
                  {{ index + 1 }}/{{ courseList.length }}
                </div>
              </div>
            </div>
          </swiper-video>
          <bjdoc-video
              v-show="playStatus"
              ref="childVideo"
              :showVedio="showVedio"
              :userInfo="userInfo"
              :videoDetail="courseList[swiperIndex]"
              :videoId="videoId"
              isHfindex="true"
              @hideVedio="hideVedio"
              @isUserLogin="isUserLogin"
              @playerBuriedpoint="playerBuriedpoint"
          ></bjdoc-video>
          <doctor-info
              :swiperIndex="swiperIndex"
              :videoInfo="videoInfo"
          ></doctor-info>
          <div class="content">
            <div
                v-for="(item, index) in courseList"
                :key="index"
                class="tag-video-item"
                @click="handleClickItem(index)"
            >
              <div
                  :style="{
                  border: currIndex === index ? '1px solid #D4A437' : '',
                  backgroundImage: 'url(' + item.imgUrl + ')'
                }"
                  class="bgPic"
              ></div>
              <p :style="{ color: currIndex === index ? '#D4A437' : '' }">
                {{ item.name }}
              </p>
              <div
                  v-if="item.courseTag"
                  :style="{
                  borderLeft: currIndex === index ? '1px solid #D4A437' : '',
                  borderTop: currIndex === index ? '1px solid #D4A437' : ''
                }"
                  class="small-tag"
              >
                {{ item.courseTag }}
              </div>
            </div>
          </div>
        </div>
        <div class="line"></div>
        <van-sticky :offset-top="0">
          <div class="tab-btn">
            <span
                v-for="(item, index) of tabList"
                :key="index"
                :class="[index === tabCur ? 'tab-active' : '']"
                @click="scrlloDis(index)"
            >{{ item }}</span
            >
          </div>
        </van-sticky>

        <div class="anchor">
          <foodmenu
              :foodHtml="videoInfo.information"
              :isLine="false"
          ></foodmenu>
        </div>

        <comment-field
            ref="focus"
            :articalId="videoInfo.id"
            :carrierId="carrierId"
            :isGoLogin="isGoLogin"
            :title="videoInfo.name"
        >
          <!-- 点赞模块 -->
          <template slot="audio">
            <span class="commentShare" @click.stop="onLike(videoInfo.orLike)">
              <div>
                <img
                    :src="
                    !videoInfo.orLike
                      ? require('@assets/images/icon/like_.png')
                      : require('@assets/images/icon/like2.png')
                  "
                />
                <span class="num">{{ fomatterNum(videoInfo.like) }}</span>
              </div>
            </span>
            <!-- 收藏 -->
            <span
                class="commentShare share3"
                @click.stop="onCllect(videoInfo.orFavorites)"
            >
              <div>
                <img
                    :src="
                    !videoInfo.orFavorites
                      ? require('@assets/images/icon/praise_.png')
                      : require('@assets/images/baby/icon2.png')
                  "
                    alt
                    class="share2 collect-shareshare"
                />
                <span class="num">{{ fomatterNum(videoInfo.collect) }}</span>
              </div>
            </span>

            <span class="commentShare share2" @click.stop="shareTap(videoInfo)">
              <div>
                <img alt class="share1" src="@assets/images/icon/share_.png"/>
              </div>
            </span>
          </template>
          <template slot="rightbtn">
            <div class="point-exchange">
              <div class="point-exchange-info">
                <span class="text-top" @click="exchange">{{
                    exchangeTips
                  }}</span>
                <span class="text-bottom">
                  <!-- {{ courseList[courseList.length - 1].isGreat }} -->
                  {{
                    swiperIndex === courseList.length - 1 &&
                    courseList[courseList.length - 1].isGreat
                        ? videoInfo.pageCumulativeNum + "位宝妈已兑换"
                        : courseList[swiperIndex]
                            ? courseList[swiperIndex].playerNum + "位宝妈已观看"
                            : ""
                  }}
                </span>
              </div>
            </div>
          </template>
        </comment-field>
        <div class="anchor">
          <all-comment
              ref="allComment"
              :articalId="videoInfo.id"
              :carrierId="carrierId"
              :isGoLogin="isGoLogin"
              :title="videoInfo.name"
              @focusOn="getFocusOn"
              @type="getType"
          ></all-comment>
        </div>
        <login-tip
            :show="checkLogin"
            @cancleWay="cancleWay"
            @confirmWay="confirmWay"
        ></login-tip>
        <share-wx ref="sharEntry"></share-wx>
        <van-dialog
            v-model="showExchangePoint"
            :before-close="payPointConfirm"
            :message="
            `${
              videoInfo.pageCumulativeNum > 0
                ? '已有' + videoInfo.pageCumulativeNum + '星妈兑换成功'
                : ''
            }`
          "
            :title="
            `是否确认使用${Masterrule[getmotherState().code]}积分兑换&quot;${
              videoInfo.name
            }&quot;课程`
          "
            confirm-button-color="#F1BA3B"
            show-cancel-button
        ></van-dialog>
        <div class="canvasposter" @touchmove.prevent @mousewheel.prevent>
          <div class="share_box">
            <img
                :src="src"
                alt=""
                class="share-image"
                @touchend="posterSaveEnd($event)"
                @touchstart="posterSaveStart($event)"
            />
            <canvasPoster
                :painting="painting"
                class="poster"
                @fail="fail"
                @success="success"
            >
            </canvasPoster>
          </div>
        </div>
      </template>
      <template v-else>
        <empty-list emptyText="课程内容已下架"></empty-list>
      </template>
    </template>
  </div>
  <div v-else>
    <!-- 您好，课程已进行调整，点击查看最新课程 -->
    <van-dialog v-model="show" title="您好，课程已进行调整，点击查看最新课程" @confirm="jumpDoctorHome">
    </van-dialog>
  </div>
</template>
<script>
import canvasPoster from "@/components/poster/doctor-canvas-poster.vue" //疫情星妈课堂海报
import {drawPoster} from "@/components/poster/posterjs/painter.js" //疫情星妈课堂海报
import taskMinxin from "@/minxs/taskFinish" //混入完成任务方法
import * as until from "@/assets/js/common.js" //公共方法
import {getCookie, getHeadImgAndName, globalGoLogin, setCookie} from "@/assets/js/common.js"
import API from "@/utils/axiosApi/catipaldoctorApi" //api
import API_ from "@/utils/axiosApi/foodApi" //api
import loadcomponent from "./component/index" //加载组件
import commentField from "@/components/comment/commentField.vue" // 输入框组件
import allComment from "@/components/comment/allComment.vue" //评论组件
import bjdocVideo from "../foodColumn/component/video" //视频播放组件
import loginTip from "@/views/contents/calendar/component/logintip" //注册提示组件
import swiperVideo from "@/components/common/mySwiper/mySwiper" //swiper组件
import foodmenu from "../foodColumn/component/foodmenu.vue" //详情菜单配置组件
import goBack from "@/components/common/goBack" //返回组件
import shareWx from "@/components/comment/share" //辅食微信指导弹框
import emptyList from "@/components/contents/emptyList.vue"
import http from "@/utils/http"; //无数据组件

export default {
  name: "bjdoctorDetail",
  data() {
    return {
      isloading: true,
      showCourseShelf: false,
      showExchangePoint: false,
      checkLogin: false,
      exchangeTips: "",
      videoId: 0,
      swiperIndex: 0,
      courseList: [],
      tabCur: 0,
      tabList: ["详情", "评论"],
      carrierId: "8",
      showVedio: false,
      foodPause: require("@assets/images/food/food_pause.png"),
      foodPlay: require("@assets/images/food/food_play.png"),
      playStatus: false,
      Masterrule: {},
      scroll: 0,
      //用户信息
      userInfo: JSON.parse(localStorage.getItem("userInfo")),
      videoInfo: {},
      playIndex: 0,
      isDiamonds: false,
      scanCode: false,
      painting: {},
      src: "",
      currIndex: 0,
      show: true
    }
  },
  mixins: [taskMinxin],
  components: {
    ...loadcomponent,
    commentField,
    allComment,
    bjdocVideo,
    loginTip,
    swiperVideo,
    foodmenu,
    goBack,
    shareWx,
    emptyList,
    canvasPoster
  },
  computed: {
    showPointTag() {
      return !this.isPaypoint && this.Masterrule[this.getmotherState().code]
    },
    isPaypoint() {
      return this.videoInfo.paySuccess
    },
    isGoLogin() {
      return until.isUserLogin()
    }
  },

  methods: {
    setCookie,
    fomatterNum: until.fomatterNum,
    getmotherState: until.getmotherState,
    drawPoster,
    getCookie,
    jumpDoctorHome() {
      this.$router.push("/bjdoctor")
    },
    // 星妈课堂疫情
    posterSaveStart: function (e) {
      e.stopPropagation()
      clearTimeout(this.posterTime)
    },
    posterSaveEnd: function (e) {
      e.stopPropagation()
      clearTimeout(this.posterTime)
    },
    doctorShare(weekCourse, name) {
      weekCourse = this.videoInfo
      sensors.track("JCMY_share", {
        Share_button_location: "详情页分享",
        content_title: weekCourse.name
      })
      if (this.isGoLogin) {
        // this.$router.push({
        //   path: "/phoneLogin?redirect=" + window.location.href
        // })
        globalGoLogin()
      } else {
        if (
            this.getCookie("xmh_openid") == null ||
            this.getCookie("xmh_openid") == ""
        ) {
          location.href =
              "/xmh/v2/wechat/oauth2/authorize?url=" +
              encodeURIComponent(window.location.href)
        } else {
          $(".canvasposter").css("display", "block")
          this.posterMsg = weekCourse
          this.posterMsg.title = weekCourse.name
          this.posterMsg.crmId = btoa(until.getUserInfo())
          this.posterMsg.nickName = btoa(
              encodeURIComponent(this.getCookie("xmh_nickname"))
          )
          this.posterMsg.mobile = btoa(this.userInfo.mobile)
          this.posterMsg.sign = this.$route.query.sign
              ? this.$route.query.sign
              : "0"
          const params = {
            type: "doctor"
          }
          this.drawPoster(params, this.posterMsg).then((res) => {
            console.log(res)
            this.painting = res
          })
        }
      }
    },
    // 星妈课堂疫情海报保存
    success(src) {
      this.src = src
    },
    fail(err) {
      console.log("fail", err)
    },
    getUserName: async function () {
      try {
        const {headImgurl, nickName} = await getHeadImgAndName()
        this.setCookie("xmh_headimgurl", headImgurl, 365)
        this.setCookie("xmh_nickname", nickName, 365)
      } catch (err) {
      }
    },
    isUserLogin() {
      if (until.isUserLogin()) {
        this.checkLogin = true
        this.$refs.childVideo.Player.pause()
      }
    },
    confirmWay() {
      this.checkLogin = false
      this.$refs.childVideo.isLogin()
      // 未注册用户弹窗确定埋点
      this.loginRegistSensors("确定")
    },
    loginRegistSensors(msg) {
      sensors.track("Login_registration_pop_up", {
        operation: msg,
        page_name: "京城名医"
      })
    },
    cancleWay() {
      this.$refs.childVideo.currentTime = 9
      this.$refs.childVideo.Player.pause()
      this.checkLogin = false
      this.loginRegistSensors("取消")
    },
    playerBuriedpoint({num, total, percent}) {
      this.playIndex++
      if (this.playIndex == 1) {
        sensors.track("Audio_and_video_playback", {
          content_id: this.videoInfo.id,
          content_title: this.courseList[this.swiperIndex].name,
          length_of_time: total,
          content_topic: this.videoInfo.typeName,
          position: 0,
          Membership_level: this.getmotherState().name,
          video_duration: num,
          is_finished: percent >= 0.8 ? true : false,
          Content_column: "京城名医",
          is_nutrition_sector: this.$route.query.sign != 0 ? true : false
        })
      }
    },
    getUserGrade(id) {
      API.getUserGrade({crmId: until.getUserInfo()}, (res) => {
        if (res.code == 200) {
          http.get(
              "/newMember/getUserScore",
              {
                crmId: until.getUserInfo(),
                unionId: this.getCookie("xmh_unionid")
              },
              data => {
                if (data.code == 200) {
                  localStorage.setItem(
                      "memberShip",
                      JSON.stringify({
                        ...res.data,
                        name: res.data.currentGrade,
                        code: res.data.code,
                        currentPoint: data.data.scoreBalance // 积分
                      })
                  );
                }
              },
              null,
              "lucky"
          );

          const {code} = this.getmotherState()
          this.initdetail(id, code)
        }
      })
    },
    initdetail(id, code) {
      let date = new Date()
      let year = date.getFullYear()
      API.catipalDcotorDetail(
          {},
          {crmId: until.getUserInfo(), memberLevelCode: code, id: id},
          (result) => {
            this.isloading = false
            if (result.code === "200") {
              const {
                courseCourseTag,
                theaterCourseTag,
                tipsCourseTag,
                courseName,
                courseImgUrl,
                courseVideoUrl,
                theaterName,
                theaterVideoUrl,
                theaterImgUrl,
                tipsName,
                tipsImgUrl,
                tipsVideoUrl,
                goidIntegral,
                platinumIntegral,
                diamondIntegral,
                tipsId,
                theaterId,
                courseId,
                theaterPlayNum,
                tipsPlayNum,
                coursePlayNum
              } = result.data
              this.Masterrule = {
                "1": goidIntegral,
                "31": platinumIntegral,
                "35": diamondIntegral
              }
              const courseData = [
                {
                  name: theaterName,
                  imgUrl: theaterImgUrl,
                  id: theaterId,
                  videoUrl: theaterVideoUrl,
                  videoStatus: 1,
                  playerStatus: false,
                  playerNum: theaterPlayNum,
                  courseTag: theaterCourseTag
                },
                {
                  name: tipsName,
                  imgUrl: tipsImgUrl,
                  id: tipsId,
                  videoUrl: tipsVideoUrl,
                  videoStatus: 1,
                  playerStatus: false,
                  playerNum: tipsPlayNum,
                  courseTag: tipsCourseTag
                },

                {
                  name: courseName,
                  imgUrl: courseImgUrl,
                  id: courseId,
                  videoUrl: courseVideoUrl,
                  videoStatus: 1,
                  playerStatus: false,
                  playerNum: coursePlayNum,
                  courseTag: courseCourseTag,
                  isGreat: 1
                }
              ]
              if (courseVideoUrl) {
                this.scanCode = true
              }
              var shareDataParams = {
                shareLink: location.href.split("#")[0],
                shareDesc: "京城名医专业护航，带你科学解锁更多育儿知识！",
                shareTitle: result.data.name,
                imgUrl:
                    "https://image-mom.feihe.com/upload/2021/08/15ea1f0f-5c84-4669-99ce-1354687d2887.png", //必须是绝对路径
                shareFlag: true,
                shareType: "jcmy",
                shareid: id
              }

              this.wxJsSet.wxShare("fx", shareDataParams, this)
              this.videoId = courseData[this.swiperIndex].id
              console.log(courseData)
              for (let index = courseData.length - 1; index > 0; index--) {
                if (!courseData[index].imgUrl) {
                  courseData.splice(index, 1)
                }
              }
              this.courseList = courseData
              this.videoInfo = result.data
              if (!this.videoInfo.information) {
                this.tabList.splice(0, 1)
              }
              console.log(this.tabList, "--------------------")
              this.exchangeTips = this.setPointTip(
                  this.swiperIndex,
                  this.Masterrule
              )
              window.addEventListener("scroll", this.pageScroll)
              this.addQrcodeNum()
            } else if (result.code === "504") {
              this.showCourseShelf = true
            } else {
              this.$toast(result.data)
            }
          }
      )
    },
    init(id) {
      this.getUserGrade(id)
    },
    payPointConfirm(action, done) {
      if (action === "confirm") {
        API.catipalDcotorPay(
            {crmId: until.getUserInfo(), id: this.$route.query.id},
            (res) => {
              if (res.code === "200") {
                this.videoInfo.paySuccess = true
                this.videoInfo.pageCumulativeNum++
                this.courseList.forEach((item, index) => {
                  if (item.isGreat) {
                    item.videoUrl = res.data
                  }
                })
                this.$toast("兑换完成")
                this.showExchangePoint = false
                this.exchangeTips = "免费观看课程"
                done()
                this.playVedio(this.courseList[this.swiperIndex])
                sensors.track("Point_exchange", {
                  Membership_level: this.getmotherState().name,
                  content_title: this.courseList[this.swiperIndex].name
                })
              } else {
                this.$toast("兑换失败,请联系客服!")
              }
            }
        )
      } else {
        done()
      }
    },

    exchange: until.Debounce(async function (item) {
      let {currentPoint, code} = this.getmotherState()
      if (this.scanCode) {
        code = "35"
      }
      const ISSWIPERTWO = this.swiperIndex === this.courseList.length - 1
      if (ISSWIPERTWO && this.isGoLogin) {
        this.$refs.childVideo.isLogin()
        return
      }
      if (
          !ISSWIPERTWO ||
          this.isPaypoint ||
          (ISSWIPERTWO && this.Masterrule[code] === 0)
      ) {
        this.playVedio(item)
        return
      }
      if (currentPoint < this.Masterrule[code]) {
        this.$toast("积分不足，无法观看")
        return
      }
      this.showExchangePoint = true
    }),
    setPointTip(index, Masterrule) {
      console.log(index, Masterrule)
      const ISTEWO = index === this.courseList.length - 1
      const TIP = "免费观看课程"
      if (this.isGoLogin && ISTEWO) {
        return "登录观看好课"
      }
      if (this.isPaypoint || !ISTEWO) {
        return TIP
      }

      let {code} = this.getmotherState()
      if (this.scanCode) {
        code = "35"
      }
      const subCanlute = (i) =>
          i === this.courseList.length - 1 && Masterrule[code] !== 0
              ? `${Masterrule[code]}积分兑换正课`
              : TIP
      // code 1为黄金星妈 31为铂金星妈 35为砖石星妈
      const rules = {
        "1": function (index) {
          return subCanlute(index)
        },
        "31": function () {
          return subCanlute(index)
        },
        "35": function (index) {
          return subCanlute(index)
        }
      }
      return rules[code](index)
    },
    /**
     * @name: 点赞
     * @param {status} Boolean
     * @return {*}
     */

    onLike(status) {
      if (this.isGoLogin) {
        this.$refs.childVideo.isLogin()
        return
      }
      API_.foodRecord(
          {},
          {
            recordType: "2",
            moduleType: "6",
            recordId: this.videoInfo.id,
            crmId: until.getUserInfo(),
            isClick: status
          },
          (res) => {
            if (res.code === "200") {
              if (status) {
                this.videoInfo.like > 0 && this.videoInfo.like--
                this.videoInfo.orLike = false
                this.praiseSaveSensor("Unsupport")
              } else {
                this.videoInfo.like++
                this.videoInfo.orLike = true
                var relation = "jcmy_praise" + this.videoInfo.id
                this.taskFinish("1") //积分任务
                this.praiseSaveSensor("Support")
              }
            }
          }
      )
    },
    /**
     * @name: 收藏
     * @param {status} Boolean
     * @return {*}
     */
    onCllect(status) {
      if (this.isGoLogin) {
        this.$refs.childVideo.isLogin()
        return
      }
      API_.foodRecord(
          {},
          {
            recordType: "1",
            moduleType: "6",
            recordId: this.videoInfo.id,
            crmId: until.getUserInfo(),
            isClick: status
          },
          (res) => {
            if (res.code === "200") {
              if (status) {
                this.praiseSaveSensor("CancelSave")

                this.videoInfo.collect > 0 && this.videoInfo.collect--
                this.videoInfo.orFavorites = false
              } else {
                this.videoInfo.collect++
                this.videoInfo.orFavorites = true
                var relation = "jcmy_collect" + this.videoInfo.id
                this.taskFinish("2") //积分任务
                this.praiseSaveSensor("Save")
              }
            }
          }
      )
    },
    praiseSaveSensor(type) {
      sensors.track(type, {
        content_id: this.videoInfo.id,
        content_title: this.videoInfo.name,
        Column: "京城名医",
        Poster_Date: ""
        // A_B_flow: this.ABtest,
      })
    },

    // 返回
    goBack() {
      if (window.history.length > 1 && until.getCookie("fromPath")) {
        this.$router.back(-1)
      } else {
        this.$router.push("/bjdoctor")
      }
    },
    slideChange(index) {
      if (this.swiperIndex === index) {
        return
      }
      this.swiperIndex = index
      this.videoId = this.courseList[this.swiperIndex].id
      this.exchangeTips = this.setPointTip(this.swiperIndex, this.Masterrule)
      this.currIndex = index
    },
    pageScroll: function () {
      this.scroll =
          document.documentElement.scrollTop || document.body.scrollTop
      this.loadSroll()
    },
    clearTime() {
      const end = new Date(
          new Date(new Date().toLocaleDateString()).getTime() +
          24 * 60 * 60 * 1000 -
          1
      ).getTime() //存一下当天23：59：59秒
      const start = new Date().getTime() //现行时间戳
      if (localStorage.getItem("endTime")) {
        if (start > localStorage.getItem("endTime")) {
          localStorage.removeItem("foodCurrentTime")
          localStorage.removeItem("saveFoodGroth") //清除本地已看视频id 第二天从头播放
          localStorage.setItem("endTime", end)
        }
      } else {
        localStorage.setItem("endTime", end)
      }
    },
    loadSroll() {
      this.$nextTick(() => {
        let anchorDom = document.querySelectorAll(".anchor")
        anchorDom.forEach((item, index) => {
          if (
              this.scroll > item.offsetTop - 150 &&
              this.scroll < item.offsetTop + item.offsetHeight - 10
          ) {
            this.tabCur = index
          }
        })
      })
    },

    /**
     * @description:
     * @param {*} bool Boolean
     * @return {*}
     */

    getFocusOn(bool) {
      this.$refs.focus.isFocus = bool
    },
    /**
     * @description:
     * @param {*} type string
     * @return {*}
     */

    getType(type) {
      this.$refs.focus.type = type
    },
    shareTap: until.Debounce(function (item) {
      // if (this.isGoLogin) {
      //   this.$refs.childVideo.isLogin();
      //   return
      // }
      API_.addPlayVideoNum(
        {},
        { id: item.id, recordType: "3", moduleType: "6" },
        (res) => {
          //  var relation = "foodshare" + item.id;
          //  this.$refs.focus.taskFinish("分享成功，成长值+", relation, "3");
          // this.$refs.sharEntry.showShareVideo();
          this.praiseSaveSensor("Share")
        }
      )
      this.doctorShare()
    }),

    hideVedio() {
      this.showVedio = false
      this.playStatus = false
    },
    addplayerNum(item) {
      API_.foodaddPlay(
          {},
          {id: item.id, moduleType: "6", recordType: "4"},
          (res) => {
            if (res.code == 200) {
              item.playStatus = !item.playStatus
              this.courseList[this.swiperIndex].playerNum++
            }
          }
      )
    },
    playVedio(item) {
      this.playStatus = !this.playStatus
      if (this.playStatus) {
        this.showVedio = true
        this.$refs.childVideo.initPlayer()
        this.clearTime()
        !item.playStatus ? this.addplayerNum(item) : ""
      }
    },
    scrlloDis(index) {
      let step = document.querySelectorAll(".anchor")
      // 滚动到指定元素
      step[index].scrollIntoView(false)
      this.tabCur = index
    },
    // 二维码分享活动扫码量增加
    addQrcodeNum() {
      let queryInfo = this.$route.query
      // 判断是否是分享二维码进来的
      if (queryInfo.id && queryInfo.crmId) {
        this.$http.post(
            "/starMom/getUser",
            {},
            {crmId: atob(queryInfo.crmId)},
            (res) => {
              if (res.code === "200") {
                // open_id是否存在
                let isCancel = res.data.memberChannel.some((item, index) => {
                  return item.account_type === "open_id"
                })
                // 判断二维码分享者是否处于注销状态 isCancel为true并且mobile存在 未注销状态
                if (isCancel && res.data.mobile && res.data.mobile.length > 0) {
                  // 分享二维码进入请求
                  const {id: capitalId, crmId} = this.$route.query
                  API.addQrcode({}, {capitalId, crmId: atob(crmId)}, (res) => {
                    if (res.code == "200") {
                      sensors.track("Code_scanning_times", {
                        content_title: this.videoInfo.name
                      })
                    }
                  })
                }
              }
            }
        )
      }
    },

    //单击视频标签内容
    handleClickItem(index) {
      this.currIndex = index
      this.$nextTick(() => {
        this.$refs.swiper.jumpSwiper(index)
      })
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.pageScroll)
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // console.log(from)
      sensors.track("enter_nutrition_sector", {
        is_nutrition_sector: from.query.sign ? true : false,
        Link_address: location.origin + from.fullPath
      })
      console.log(location.origin + from.fullPath)
    })
  },
  mounted() {
    this.isDiamonds = this.$route.query.isDiamonds == 1 ? true : false
    this.init(this.$route.query.id)
    this.getUserName()
    // this.$nextTick(() => {
    //   if (!this.videoInfo.information) {
    //     this.tabList.split(0, 1)
    //   }
    //   console.log(this.tabList, "--------------------")
    // })
  }
}
</script>
<style lang="less" scoped>
@import "./less/detail.less";

.vedio-box {
  .van-dialog {
    /deep/ .van-dialog__header {
      width: 80%;
      margin: 0 auto;
    }

    /deep/ .van-dialog__message {
      color: #999;
      padding-top: 12px;
    }
  }
}
</style>
